export default {"src":"/_next/static/media/campaigns.d06f3b96.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};